var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"life-table"},[_c('h1',[_vm._v("収支表")]),_vm._v(" "),_c('InputForm'),_vm._v(" "),_c('LifeTable',{attrs:{"inOut2":_vm.inOut}}),_vm._v(" "),_c('MoneyGraph')],1)}
var staticRenderFns = []

export { render, staticRenderFns }